module.exports = __webpack_public_path__ + "img/123-eryaxindahei-fcc.fe84f113.png";